import { buildRequestUriFromUrl, setEnvironmentRequestUri, PARENT_ORIGIN_KEY } from '@libs/core';
import React, { useEffect } from 'react';
import { useNavigate, useLocation, useSearchParams } from 'react-router';

export const DeepLinkPage = () => {
    const navigation = useNavigate();
    const location = useLocation();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        setEnvironmentRequestUri(buildRequestUriFromUrl(location.pathname, searchParams));
        const parentOrigin = searchParams.get(PARENT_ORIGIN_KEY);
        if (parentOrigin) {
            sessionStorage.setItem(PARENT_ORIGIN_KEY, parentOrigin);
        }
        navigation('/', { replace: true });
    }, [location.pathname, navigation, searchParams]);

    return <h1>Loading</h1>;
};
